import { Component, Input, OnInit, Output } from "@angular/core";
import { FormGroup } from "@angular/forms";
import { IChoiceMetaDataSettings, IMetaData } from "src/app/interfaces";

@Component({
    selector: "circ-metadata-choice",
    templateUrl: "./choice.component.html",
    styleUrls: ["./choice.component.scss"],
    standalone: false
})
export class ChoiceComponent implements OnInit {
  @Input()
  @Output()
  public data: IMetaData;

  @Input()
  public formGroup: FormGroup;

  public settings: IChoiceMetaDataSettings;

  ngOnInit(): void {
    this.settings = {
      ...this.data.settings
    } as IChoiceMetaDataSettings;
  }
}
